/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : App.tsx
 *
 * Project Title : RDR7000
 *
 * Description   : Root App component
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Amol Jagtap (H409453)
 *
 * @Date         : July 31, 2020
 *
 * @Version      : Version 1.0
 *
 * By            : Amol Jagtap (H409453)
 * On            : July 31, 2020
 * Description   : Added for root component, all component will be child componet of this root component
 *
 *
 ******************************************************************************/

import React, { FC } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from 'components/Auth';
import { Routes } from './Routes';

declare global {
  interface Window {
    envVars: any;
  }
}

export const App: FC = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes />
      </Router>
    </AuthProvider>
  );
};
